import { render } from "./Loader.vue?vue&type=template&id=3a333e82&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=3a333e82&scoped=true&lang=scss"

import exportComponent from "C:\\Git\\Odelib\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a333e82"]])

export default __exports__